import { render } from "./InputPassportScanner.vue?vue&type=template&id=353ede4e"
import script from "./InputPassportScanner.vue?vue&type=script&lang=js"
export * from "./InputPassportScanner.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__